<div class="profile__feed profile__feed--active">
  <div
    class="profile__post feed_css"
    *ngFor="let data of feedList; let i = index"
    infiniteScroll
    [infiniteScrollDistance]="10"
    [infiniteScrollThrottle]="150"
    (scrolled)="usedFor == 'home' || usedFor == 'PendingReview' ? '' : onScroll($event)"
  >
    <figure class="profile__feed__img">
      @if (data.postMedias.length > 0 && isInitialized) {
        <owl-carousel-o [options]="customOptions">
          <ng-container *ngFor="let item of data.postMedias">
            <ng-template carouselSlide>
              @if (item.mediaType == 'image') {
                <img
                  [src]="fileDirectoriesPath + item.mediaUrl"
                  alt="Experiencing Snowboarding"
                  class="profile__post-image"
                  (click)="userDetail?.id ? getDetail(data) : moveToRegister()"
                />
              }
              @if (item.mediaType == 'video') {
                <video
                  #videoPlayer
                  poster=""
                  class="profile__post-image"
                  preload="metadata"
                  [src]="fileDirectoriesPath + item.mediaUrl"
                  (click)="userDetail?.id ? getDetail(data) : moveToRegister()"
                >
                  <source [src]="fileDirectoriesPath + item.mediaUrl" type="video/mp4" />
                </video>
              }
              <figcaption>
                @if (data.isFeatured) {
                  <div class="user-directory__action info__more">Featured</div>
                }
                @if (usedFor == 'myFeed' && data.reviewStatus == 'pending') {
                  <span class="user-directory__status user-directory__status--pending position__top"
                    >Review pending

                    <img
                      src="assets/images/ic_info_blue.svg"
                      alt="Review pending"
                      class="info__icon tootltip_new"
                      [ngbTooltip]="pendingReview"
                      placement="bottom"
                      container="body"
                      tooltipClass="reviewTooltip"
                    />
                    <ng-template #pendingReview>
                      <div class="tooltip__data user-directory__status--pending">
                        The review is currently awaiting evaluation from the assigned experts.
                      </div>
                    </ng-template>
                  </span>
                }
                @if (usedFor == 'myFeed' && data.reviewStatus == 'not_required') {
                  <span class="user-directory__status user-directory__status--notRequired position__top"
                    >Not required
                    <img
                      src="assets/images/ic_info-grey.svg"
                      alt="Not required"
                      class="info__icon tootltip_new"
                      [ngbTooltip]="notRequiredReview"
                      placement="bottom"
                      container="body"
                      tooltipClass="reviewTooltip"
                    />
                    <ng-template #notRequiredReview>
                      <div class="tooltip__data user-directory__status--notRequired">
                        No review is necessary as this sport follows an objective scoring system with a direct score assigned.
                      </div>
                    </ng-template>
                  </span>
                }
                @if (usedFor == 'myFeed' && data.reviewStatus == 'rejected') {
                  <span class="user-directory__status user-directory__status--danger position__top"
                    >Review rejected
                    <img
                      src=" assets/images/ic_info-danger.svg"
                      alt="Review rejected"
                      class="info__icon tootltip_new"
                      [ngbTooltip]="rejectedReview"
                      placement="bottom"
                      container="body"
                      tooltipClass="reviewTooltip"
                    />

                    <ng-template #rejectedReview>
                      <div class="tooltip__data user-directory__status--danger">
                        The review was rejected as it failed to meet the minimum required criteria, specifically because this is not classified as an
                        extreme sport on our platform.
                      </div>
                    </ng-template>
                  </span>
                }
                @if (usedFor == 'myFeed' && data.reviewStatus == 'completed') {
                  <span class="user-directory__status user-directory__status--completed position__top"
                    >Review completed
                    <img
                      src="assets/images/ic_info-green.svg"
                      alt="Review completed"
                      class="info__icon tootltip_new"
                      [ngbTooltip]="completedReview"
                      placement="bottom"
                      container="body"
                      tooltipClass="reviewTooltip"
                    />
                    <ng-template #completedReview>
                      <div class="tooltip__data user-directory__status--completed">The review has been finalized and assessed by 5 experts.</div>
                    </ng-template>
                  </span>
                }
                @if (usedFor == 'myFeed') {
                  <div
                    ngbDropdown
                    class="user-directory__action info__more_action"
                    container="body"
                    placement="bottom-right"
                    dropdownClass="feedMoreDropdown"
                  >
                    <div class="moreicon" ngbDropdownToggle data-bs-toggle="dropdown" [innerHTML]="ICONS.moreIcon | safeHtml"></div>

                    <ul class="dropdown-menu_feed dropdown__option--small" ngbDropdownMenu>
                      <li ngbDropdownItem class="dropdown__option--list" *ngIf="data.reviewStatus != 'rejected'">
                        <a class="dropdown__item" (click)="editFeed(data)">Edit</a>
                      </li>

                      <li ngbDropdownItem class="dropdown__option--list handPointer" (click)="deleteFeed(data)">
                        <a class="dropdown__item">Delete</a>
                      </li>
                    </ul>
                  </div>
                }
              </figcaption>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      }

      @if (usedFor == 'searchFeed') {
        <!-- tooltip start -->
        <div class="feedTooltip">
          <span class="feedTooltip__points-value">{{ data?.averageExpertScores | number: '1.0-0' }} Points</span>
          <!-- <span class="infoIcn">
            <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="#fff">
              <path
                d="M480-680q-33 0-56.5-23.5T400-760q0-33 23.5-56.5T480-840q33 0 56.5 23.5T560-760q0 33-23.5 56.5T480-680Zm-60 560v-480h120v480H420Z"
              />
            </svg>
          </span>
          <div class="show__feedTooltip">
            <div class="feedTooltip-row">
              <div class="feedTooltip-col">
                <p>Stakeboarding</p>
                <b>230 points</b>
              </div>
              <div class="feedTooltip-col">
                <p>Ice</p>
                <b>315 points</b>
              </div>
            </div>
          </div> -->
        </div>
        <!-- tooltip End -->
      }
    </figure>
    <div class="profile__post-content searchFeed">
      <h3 class="profile__post-title handPointer" (click)="userDetail?.id ? getDetail(data) : moveToRegister()">{{ data?.title || '' }}</h3>

      <div class="searchAction">
        <span class="likewrap">
          <span
            class="{{ data?.isCurrentUserLiked ? 'likeRedCount likeCount' : 'likeCount' }}"
            (click)="userDetail?.id ? likeFeeds(data?.id, userDetail?.id, data, i) : moveToRegister()"
          >
            <!-- <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor">
              <path
                d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Z"
              />
            </svg> -->
            <div [innerHTML]="ICONS.likeIcon | safeHtml"></div>
          </span>
          <span class="handPointer" (click)="userDetail?.id ? openLikeList(data) : moveToRegister()">{{ data?.likeCount || 0 }}</span>
        </span>

        <span class="commentCount" (click)="userDetail?.id ? openCommentList(data) : moveToRegister()">
          <div [innerHTML]="ICONS.commentIcon | safeHtml"></div>
          {{ data?.commentCount || 0 }}</span
        >
      </div>

      @if (usedFor != 'searchFeed' && usedFor != 'myFeedUser') {
        <div class="score">
          <div class="score__value handPointer" (click)="userDetail?.id ? getDetail(data) : moveToRegister()">
            <span class="score__number">{{ data?.selfScore || 0 }}</span>
            <span class="score__label">Self Score</span>
          </div>

          <!-- @if (!(data.reviewStatus == 'pending')) { -->
          <div class="score__value handPointer" (click)="userDetail?.id ? getDetail(data) : moveToRegister()">
            <span class="score__number">{{ data?.averageExpertScores || 0 }}</span>
            <span class="score__label">Average score</span>
          </div>
          <!-- } -->
          @if (data?.canBeScored && usedFor != 'public' && usedFor != 'myFeed') {
            <button class="score__button" (click)="openScoreUserPopup(data)">Assign score</button>
          }
        </div>
      }
    </div>
    <div class="profile__post-footer handPointer" (click)="userDetail?.id ? userSearch(data) : moveToRegister()">
      <div class="profile__post-user">
        <img
          [src]="data.user?.profilePicture ? fileDirectoriesPath + data.user?.profilePicture : 'assets/images/img_profile.png'"
          [alt]="data.user?.name"
          class="profile__post-user-photo"
        />
        <div class="user__info">
          <span class="profile__post-user-name">{{ data.user?.alias ? data.user?.alias || '-' : data.user?.name || '-' }}</span>
          <span class="profile__post-user-location">{{ data.location || '-' }}</span>
        </div>
      </div>
      @if (usedFor != 'searchFeed' && usedFor != 'myFeedUser') {
        <div class="tags">
          <span
            class="activity__tag handPointer"
            (click)="userDetail?.id ? $event.stopPropagation() : moveToRegister()"
            [routerLink]="userDetail?.id ? '/sports' : ''"
            [queryParams]="{ element: data?.level?.sport?.category?.element?.name }"
            >{{ data?.level?.sport?.category?.element?.name }}</span
          >
          <span class="activity__tag">{{ data?.level?.sport?.category?.name }}</span>
        </div>
      }
      @if (usedFor == 'searchFeed') {
        <div class="tags">
          <span
            class="activity__tag handPointer"
            (click)="userDetail?.id ? $event.stopPropagation() : moveToRegister()"
            [routerLink]="userDetail?.id ? '/sports/' + data?.level?.sportId : ''"
            >{{ data?.level?.sport?.name }}</span
          >
        </div>
      }
    </div>
  </div>
  <div class="searchResult" *ngIf="pagination.row == 0 && feedList.length == 0 && pagination.text != 'Loading...' && usedFor != 'searchFeed'">
    <div class="searching text-center">
      <h5>{{ pagination.text || '' }}</h5>
    </div>
  </div>

  <div class="searchResult" *ngIf="pagination.row == 0 && feedList.length == 0 && pagination.text != 'Loading...' && usedFor == 'searchFeed'">
    <div class="searching text-center">
      <img src="../../../assets/images/noSearchFound.gif" alt="no search found" />
      <h2>
        Sorry we couldn't find any results for <br />
        {{ searchContant }}
      </h2>
      <h5>Please try searching with a different name</h5>

      <button
        class="popup__button popup__apply"
        data-bs-toggle="offcanvas"
        data-bs-target="#searchOffcanvasTop"
        aria-controls="searchOffcanvasTop"
        (click)="onSearchClick()"
      >
        Try now
      </button>
    </div>
  </div>
</div>
